export interface Team {
  _id: string;
  name: string;
  description?: string;
  isActive?: boolean;
  memberCount?: number;
}

export enum AgentStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum AgentRole {
  APP_ADMIN = "app_admin",
  APP_AGENT = "app_agent",
}

export interface Agent {
  _id: string;
  name: string;
  email: string;
  profileImage?: string;
  phone?: string;
  teams: string[];
  permissions: AgentRole[];
  status: AgentStatus;
  /** Agente sem login humano, existe só pra portar um token MCP (automação via Claude/outros). */
  isBot?: boolean;
}
